import a from "./td-longtail-vue-components199.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var n = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("div", { staticClass: "accordion-item", class: {
    "accordion-item--inactive-desktop": e.isOpenOnDesktop
  } }, [i(t.LinkButton, { staticClass: "accordion-item__title", class: {
    "accordion-item__title--small": e.isSmall
  }, attrs: { id: `accordionItemTitle${t.uid}`, type: "button", tag: "button", "no-styling": "", "aria-controls": `accordionItemPanel${t.uid}`, "aria-expanded": t.ariaIsOpen.toString(), "data-testid": "accordionItemTitle" }, on: { click: t.toggleIsOpen, keydown: t.handleKeydown } }, [e._t("title"), i(t.Arrow, { staticClass: "accordion-item__icon", attrs: { direction: t.isOpenDerived ? "top" : "bottom", "aria-hidden": "true", tag: "span" } })], 2), i(t.TransitionExpand, [i("div", { directives: [{ name: "show", rawName: "v-show", value: t.isOpenDerived, expression: "isOpenDerived" }], staticClass: "accordion-item__panel", attrs: { id: `accordionItemPanel${t.uid}`, "aria-labelledby": `accordionItemTitle${t.uid}`, "aria-hidden": !t.ariaIsOpen, role: e.role, "data-testid": "accordionItemPanel" } }, [i("div", { staticClass: "accordion-item__content", attrs: { "data-testid": "accordionItemContent" } }, [e._t("content")], 2)])])], 1);
}, r = [], s = /* @__PURE__ */ o(
  a,
  n,
  r,
  !1,
  null,
  "775b5267"
);
const _ = s.exports;
export {
  _ as default
};
